export const state = {
    loadingLayoutTotem: false,
    corPadrao: null,
    corFonte: null,
    logo: null,
}

export const mutations = {
    SET_LOADING_LAYOUT_TOTEM(state, status) {
        state.loadingLayoutTotem = status
    },

    SET_COR_PADRAO(state, payload) {
        state.corPadrao = payload
        if (state.corPadrao) {
            updateCorPadraoLocalStorage(state.corPadrao)
        }
    },

    SET_COR_FONTE(state, payload) {
        state.corFonte = payload
        // if (state.corFonte) {
        //     updateCorFonteLocalStorage(state.corFonte)
        // }
    },
    
    SET_LOGO(state, payload) {
        state.logo = payload
        if (state.logo) {
            updateLogoLocalStorage(state.logo)
        }
    },   
}

export const actions = { 
    changeLoadingLayoutTotem({ commit }, status) {
        commit('SET_LOADING_LAYOUT_TOTEM', status)        
    },

    changeCorPadrao({ commit }, payload) {
        commit('SET_COR_PADRAO', payload)        
    },

    changeCorFonte({ commit }, payload) {
        commit('SET_COR_FONTE', payload)        
    },


    changeLogo({ commit }, payload) {
        commit('SET_LOGO', payload)        
    },

    setCorPadraoFromLocalStorage({ commit }) {
        const corPadrao = localStorage.getItem('corPadrao')
        if (corPadrao) {
            commit('SET_COR_PADRAO', corPadrao)
        }
    },

    // setCorFonteFromLocalStorage({ commit }) {
    //     const corFonte = localStorage.getItem('corFonte')
    //     if (corFonte) {
    //         commit('SET_COR_FONTE', corFonte)
    //     }
    // },

    setLogoFromLocalStorage({ commit }) {
        const logo = localStorage.getItem('logo')
        if (logo) {
            commit('SET_LOGO', logo)
        }
    },

    updateEtotemLayoutFromLocalStorage({ dispatch }) {        
        dispatch('setCorPadraoFromLocalStorage')
       // dispatch('setCorFonteFromLocalStorage')
        dispatch('setLogoFromLocalStorage')
    },
}

// Updates do localStorage
function updateCorPadraoLocalStorage(corPadrao) {
    localStorage.setItem('corPadrao', corPadrao)
}

// function updateCorFonteLocalStorage(corFonte) {
//     localStorage.setItem('corFonte', corFonte)
// }

function updateLogoLocalStorage(logo) {
    localStorage.setItem('logo', logo)
}
